// cache-bust: force new bundle hash
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/router.tsx";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import { isIntentionalFlowPause } from "@/utils/sentry/intentional";
import { startOpenReplay } from "@/utils/openreplay/startOpenReplay";

Sentry.init({
  dsn: "https://77edc7ec45ef1faaa9ae249cd8ddae44@sentry.vendasturbo.com/8",
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sentry self-hosted da Wing eh instancia interna restrita: trade-off
    // consciente entre o ganho marginal de privacidade ao mascarar e o
    // ganho real de poder analisar replays/eventos com dados visiveis.
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  // Liga distributed tracing entre o front e a API para correlacionar erros
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api\.planostimcelular\.com\.br/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Filtra throws marcados como "pausa intencional de fluxo" (modais de
  // troca de pagamento, autorizacao etc) para nao poluir o Sentry com erros
  // que nao sao realmente erros
  beforeSend(event, hint) {
    if (isIntentionalFlowPause(hint.originalException)) {
      return null;
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>
);

void startOpenReplay();
